// https://dev.to/basileleroy/google-analytics-on-react-js-components-4d2a
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";
import env from "../config/env";
import ReactPixel from "react-facebook-pixel";

const useGaTracker = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.initialize(env.GA_TRACKING_CODE, { debug: true });
    ReactPixel.init(env.FB_TRACKING_CODE);
  }, []);

  useEffect(() => {
    console.log(location);
    ReactGA.pageview(location.pathname + location.search);

    if (
      (location.pathname + location.search).indexOf(
        "stripe-checkout-success"
      ) >= 0
    ) {
      ReactGA.event({
        category: "Customer",
        action: "Iscrizione Abbonamento",
      });
    }
  }, [location]);
};

export default useGaTracker;
